<template>
  <div class="addCompany">
    <QS-scroller-box>
      <QS-h3-title>
        <template #title>{{ customerId ? '编辑' : '新增' }}企业客户</template>
        <div class="splitline" />
      </QS-h3-title>
      <SelectTag
        title="客户标签"
        v-model="tagList"
        :allTagList="allTagList"
        :currentTagList="currentTagList"
      />
      <AddCustomerBasicInfo
        ref="AddCustomerBasicInfo"
        :addFormData="addFormData"
        :sourceRequired="Boolean(customerId)"
      />
      <AddPayInfo
        ref="AddPayInfo"
        :addFormData="addFormData"
      />
      <AddReferrerInfo
        ref="AddReferrerInfo"
        :addFormData="addFormData"
      />
      <template #bottomAction>
        <div class="button_container">
          <el-button size="small" @click="cancel"> 取消 </el-button>
          <el-button
            :loading="submitLoading"
            @click="validateBeforeSubmit"
            type="primary"
            size="small"
          >
            {{ customerId ? '提交' : '确认新增' }}
          </el-button>
        </div>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import { customerAdd, customerEdit, getCustomerDetail } from '@/api/domain/customers.js'
import { getTenantCustomTagList } from '@/api/domain/others.js'
import SelectTag from '@/components/SelectTag'
import AddCustomerBasicInfo from '../components/AddCustomerBasicInfo'
import AddPayInfo from '../components/AddPayInfo'
import AddReferrerInfo from '../components/AddReferrerInfo'

export default {
  components: {
    SelectTag,
    AddCustomerBasicInfo,
    AddPayInfo,
    AddReferrerInfo,
  },
  data() {
    return {
      allTagList: [],
      tagList: [],
      currentTagList: [],
      addFormData: {
        customerType: 2,
      },
      customerId: null,
      submitLoading: false,
    }
  },
  methods: {
    cancel(refreshStatus = false) {
      this.$refreshBack(refreshStatus === true)
      this.$router.push({
        path: '/driver/customerManage',
        query: {
          type: 'company',
        },
      })
    },
    async submit() {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        const publicInfo = this.$refs.AddCustomerBasicInfo.publicInfo || {}
        const addPayPublicInfo = this.$refs.AddPayInfo.publicInfo || {}
        const addPayEnterpriseInfo = this.$refs.AddPayInfo.enterpriseCustomerInfo || {}
        const enterpriseCustomerInfo = Object.assign(
          {},
          this.getEnterpriseCustomerInfo(this.addFormData),
          this.$refs.AddCustomerBasicInfo.enterpriseCustomerInfo,
          addPayPublicInfo,
          addPayEnterpriseInfo,
        )
        let params = {}
        params.enterpriseCustomerInfo = enterpriseCustomerInfo
        params = Object.assign(
          {},
          this.addFormData,
          params,
          publicInfo,
          this.$refs.AddReferrerInfo.publicInfo,
        )
        params.enterpriseCustomerInfo.tagList = this.tagList
        delete params.enterpriseCustomerInfo.customerTel
        delete params.idCardNo
        delete params.contacts
        delete params.enterpriseCustomerInfo.idCardNo
        delete params.enterpriseCustomerVo
        delete params.individualCustomerVo
        params = this.filterParams(params)

        let res = null
        if (this.customerId) {
          res = await customerEdit(params)
        } else {
          res = await customerAdd(params)
        }
        if (res && res.code === 1) {
          this.$message({
            message: `${this.customerId ? '编辑' : '新增'}成功`,
            type: 'success',
          })
          this.cancel(true)
        }
      } finally {
        this.submitLoading = false
      }
    },
    async validateBeforeSubmit() {
      const flag = await this.$refs.AddCustomerBasicInfo.validate()
      if (flag) {
        this.submit()
      }
    },
    getCustomerDetail(id) {
      getCustomerDetail({ customerType: 2, id }).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          const result = this.filterImage(data)
          this.addFormData = result
          const { enterpriseCustomerVo = {} } = result
          const { tagList = [] } = enterpriseCustomerVo
          this.currentTagList = tagList
        }
      })
    },
    getTenantCustomTagList() {
      getTenantCustomTagList({
        type: 2,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.allTagList = [...data]
        }
      })
    },
    init() {
      const { id } = this.$route.query
      this.customerId = id
      if (id) {
        this.getCustomerDetail(id)
      }
      this.getTenantCustomTagList()
    },
    getEnterpriseCustomerInfo(data = {}) {
      return {
        ...(data.enterpriseCustomerVo || {}),
        ...(data.enterpriseCustomerInfo || {}),
      }
    },
    filterImage(data) {
      const result = { ...data }
      const enterpriseCustomerInfo = this.getEnterpriseCustomerInfo(result)
      if (Object.keys(enterpriseCustomerInfo).length) {
        const businessLicenceUrl = this.getEchoUploadFileData(
          enterpriseCustomerInfo.businessLicenceUrl,
          true,
        )
        result.enterpriseCustomerInfo = {
          ...enterpriseCustomerInfo,
          businessLicenceUrl,
        }
        result.enterpriseCustomerVo = {
          ...enterpriseCustomerInfo,
          ...result.enterpriseCustomerVo,
          businessLicenceUrl,
        }
      }
      return result
    },
    filterParams(data) {
      return {
        ...data,
        enterpriseCustomerInfo: {
          ...data.enterpriseCustomerInfo,
          businessLicenceUrl: this.getUoloadCommonFileData(
            data.enterpriseCustomerInfo.businessLicenceUrl,
          ),
        },
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.addCompany {
  .button_container {
    display: flex;
    justify-content: center;
  }
}
</style>
